// Internal Imports
import Dropdown, { MobileDropdown } from './components/dropdown'
import Button from "./components/button"

// Assets Imports
import TecmeLogo from './assets/images/tecme-logo.svg'
import MobileIcon from "./assets/icons/mobile.svg"
import MenuCancel from "./assets/icons/mobile-cancel.svg"
import HamburgerMenu from "./assets/icons/hamburger-menu.svg"
import MobileFacebookIcon from "./assets/icons/mobile-facebook.svg"
import MobileInstagramIcon from "./assets/icons/mobile-instagram.svg"

import './assets/css/navbar.scss'
import ROUTES from '../../../utils/routes'
import { Link, useHistory } from 'react-router-dom'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import {getMarketingWebsiteURL} from "../../../utils/helper";
const marketingWebsiteURL = getMarketingWebsiteURL()

const Navbar = () => {
    const history = useHistory()
    const user = useSelector(state => state.user)
    const tech = useSelector(state => state.tech)
    const [showMobileMenu, setShowMobileMenu] = useState(false)

    const isLoggedIn = user || tech
    
    function handleChange(option) {
        console.log(`Selected option: ${option}`);
    }

    function handleToggleMobileMenu(){
        setShowMobileMenu(!showMobileMenu)
    }

    const navItems = [
        {
            id:"business",
            title:"For Businesses",
            options: {
                top: [
                    {
                        sub_title:"Contact us",
                        href: `${marketingWebsiteURL}/contact-us`
                    },
                    // {
                    //     sub_title:"Referral program",
                    //     href: ""
                    // },
                    {
                        sub_title:"Find local specialists",
                        link:ROUTES.DISCOVERY_EXPERIENCE
                    },
                ],
                left: {
                    subHeading: 'Solutions',
                    list: [
                        {
                            sub_title: "Strategic IT guidance",
                            href: `${marketingWebsiteURL}/solutions/strategic-it-guidance/`
                        },
                        {
                            sub_title: "Network Administration",
                            href: `${marketingWebsiteURL}/solutions/network-administration/`
                        },
                        {
                            sub_title: "24/7 Monitoring Services",
                            href: `${marketingWebsiteURL}/solutions/monitoring-and-protection/`
                        },
                        {
                            sub_title: "Compliance",
                            href: `${marketingWebsiteURL}/solutions/managed-compliance/`
                        },
                        {
                            sub_title: "IT Project Management",
                            href: `${marketingWebsiteURL}/solutions/it-project-management/`
                        },
                        {
                            sub_title: "Cybersecurity",
                            href: `${marketingWebsiteURL}/solutions/cybersecurity/`
                        },
                        {
                            sub_title: "Continuous backups",
                            href: `${marketingWebsiteURL}/solutions/continuous-backups/`
                        },
                        {
                            sub_title: "Help Desk Support",
                            href: `${marketingWebsiteURL}/solutions/help-desk-support/`
                        },
                        {
                            sub_title: "Managed IT Services",
                            href: `${marketingWebsiteURL}/solutions/managed-it-services/`
                        },
                        {
                            sub_title: "Website Management",
                            href: `${marketingWebsiteURL}/solutions/website-management/`
                        }
                    ]
                },
                rightFirst: {
                    subHeading: 'Industries',
                    list: [
                        {
                            sub_title: "Healthcare",
                            href: `${marketingWebsiteURL}/solutions/healthcare/`
                        },
                        {
                            sub_title: "Franchises",
                            href: `${marketingWebsiteURL}/solutions/franchises/`
                        }
                    ]
                },
                rightSecond: {
                    subHeading: 'IT Situations',
                    list: [
                        {
                            sub_title: "No IT Provider",
                            href: `${marketingWebsiteURL}/solutions/customizable-it-management/`
                        },
                        {
                            sub_title: "In-house IT",
                            href: `${marketingWebsiteURL}/solutions/supercharge-in-house-it/`
                        },
                        {
                            sub_title: "Outsourcing IT",
                            href: `${marketingWebsiteURL}/solutions/ultimate-it-partner/`
                        }
                    ]
                }
            }
        },
        {
            id:"professionals",
            title:"For IT Professionals",
            options:[
                {
                    sub_title:"Join the TecMe network",
                    href:"https://tecme.recruitee.com/"
                },
                {
                    sub_title:"Community",
                    href:"https://hub.tecme.io/"
                },
            ]
        },
        {
            id:"resources",
            title:"Resources",
            options:[
                {
                    sub_title:"About us",
                    href: `${marketingWebsiteURL}/about`
                },
                {
                    sub_title:"Press",
                    href: `${marketingWebsiteURL}/press-room`
                },
                {
                    sub_title:"Help Center",
                    href:"https://help.tecme.io/"
                }
            ]
        },
    ]

    const mobileMenu = () => {
        return(
            <div className={`mobile-menu-container ${showMobileMenu && 'show-mobile-menu-container' }`}>
              {showMobileMenu &&
                <>
                    <div className='menu-contents h-100'>
                        {
                            navItems.map((item) => {
                                return  <MobileDropdown options={item.options} placeholder={item.title} id={item.id}  setShowMobileMenu={setShowMobileMenu} />
                            })
                        }
                    </div>
                    <div className="bottom-menu">
                        <a href="tel:+1 (888) 678-3263" className='contact'>
                            <img src={MobileIcon} />
                            (888) 678-3263
                        </a>
                        {
                        (!isLoggedIn) ?
                            <Link to={ROUTES.LOGIN} className="login-link"> Login </Link> :
                            <Link to={ROUTES.DASHBOARD} className="login-link"> My Account </Link>
                        }
                        <div className='social-icons'>
                            <img src={MobileFacebookIcon} alt="facebook icon" onClick={() => window.open("https://www.facebook.com/tecme.io")}/>
                            <img src={MobileInstagramIcon} alt="instagram icon" onClick={() => window.open("https://www.instagram.com/tecme.io")} />
                        </div>
                    </div>
                </>
                }
            </div>
        )
    }

    return (
        <div className='navbar-container'>
            <nav className={`navbar fixed-top navbar-expand-lg tecme-navbar  ${showMobileMenu && 'show-mobile-menu-tecme-navbar' }`}>
                <div className='button-logo'>
                   { !showMobileMenu ?
                   <img onClick={handleToggleMobileMenu} src={HamburgerMenu} className="nav-menu-icon" alt="hamburger menu" /> :
                    <img  onClick={handleToggleMobileMenu} src={MenuCancel} className="nav-menu-icon" alt="cancel icon" />
                    }
                    <a className="custom-navbar-brand" href="/">
                        <img src={TecmeLogo} alt="TecMe" className='tecme-logo' />
                    </a>
                </div>
                { !isLoggedIn && <Button  text='Contact us' className="contant-us-mobile" handleClick={() => window.open(`${marketingWebsiteURL}/contact-us`,'_blank')} />}

                <div className="collapse navbar-collapse right-side" id="navbarSupportedContent">
                    <ul className="navbar-nav">
                        {navItems.map((item) => {
                            return <Dropdown key={item.id} options={item.options} placeholder={item.title} id={item.id} onChange={handleChange}/>
                        })}
                        <a href="tel:+1 (888) 678-3263" className='contact'>
                            <img src={MobileIcon} />
                            (888) 678-3263
                        </a>
                        <div className='nav-divider'>|</div> 
                        {  !isLoggedIn ? <Link className="link-button" to={ROUTES.LOGIN}>Login</Link> : <Button text='My Account' className="contact-us my-account" handleClick={() => history.push(ROUTES.DASHBOARD)} />
                        }
                        {!isLoggedIn && <Button text='Contact us' className="contact-us" handleClick={() => window.open(`${marketingWebsiteURL}/contact-us`,'_blank')}/>}
                    </ul>
                </div>
            </nav>
            {mobileMenu()}
        </div>
    )
}

export default Navbar